if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // --- Casulo B2B: Cart Validation Logic (v4.3.0) ---
        const productInfo = this.closest('product-info');
        const collections = productInfo ? productInfo.dataset.productCollections : '';
        let productType = 'orcamento';
        
        if (window.CasuloCart && window.CasuloCart.Validation) {
          try {
            const validation = await window.CasuloCart.Validation.validateAddition(collections);
            if (!validation.valid) {
              this.handleErrorMessage(validation.message + ' CONFLICT_DETECTED');
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');
              return;
            }
            productType = validation.newType;
            // Add identifying property to the line item
            formData.append('properties[_product_type]', productType);
          } catch (err) {
            console.error('[CasuloCart] Validation Error:', err);
          }
        }
        // --- End Casulo B2B ---

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });

              // Sincronizar com Carrinho Virtual na API (v4.3.0)
              if (window.CasuloCart && window.CasuloCart.Validation) {
                const vid = formData.get('id');
                const pid = productInfo ? productInfo.dataset.productId : '';
                
                console.log('[CasuloCart] Sincronizando item com a API...', vid, productType);
                
                fetch('/apps/orcamento/orcamento/sync-item', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    customer_id: window.CasuloCart.Validation.getCustomerId(),
                    browser_id: window.CasuloCart.Validation.getBrowserId(),
                    variant_id: vid,
                    product_id: pid,
                    product_type: productType
                  })
                }).catch(e => console.error('[CasuloCart] Erro ao sincronizar item:', e));
              }
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          if (errorMessage.includes('CONFLICT_DETECTED')) {
             const cleanMsg = errorMessage.replace('CONFLICT_DETECTED', '').trim();
             this.errorMessage.innerHTML = `
                <div class="cart-conflict-resolution" style="margin-top: 5px;">
                   <p style="margin-bottom: 10px;">${cleanMsg}</p>
                   <div class="cart-conflict-buttons" style="display: flex; gap: 8px; flex-direction: column;">
                      <button type="button" class="button button--secondary" onclick="window.CasuloCart.Validation.resolveConflict('orcamento')" style="width: 100%; justify-content: center; font-size: 1.1rem; padding: 10px;">
                        Finalizar apenas com Sob Encomenda
                      </button>
                      <button type="button" class="button button--secondary" onclick="window.CasuloCart.Validation.resolveConflict('loja')" style="width: 100%; justify-content: center; font-size: 1.1rem; padding: 10px;">
                        Finalizar apenas com Pronta Entrega
                      </button>
                   </div>
                   <p style="font-size: 0.85em; margin-top: 12px; opacity: 0.8; line-height: 1.2;">
                    Remova itens manualmente no carrinho se preferir manter alguns de cada tipo.
                   </p>
                </div>
             `;
          } else {
             this.errorMessage.textContent = errorMessage;
          }
          this.errorMessageWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
